import classnames from "classnames";
import { CorrectLens } from "ramda";
import * as React from "react";
import { connect } from "react-redux";
import { isRequesting } from "src/requestProgress/helpers";
import { actions } from "src/requestProgress/reducer";
import { State } from "../../state";
import { formatMoneyValue } from "../../utils/formatters";
import { getHighlightedCellFn } from "../model/highlightedCells/selector";
import { AccountPresenter } from "../model/presenter/types";
import { selectCell } from "../model/selectedCells/actions";
import { getCellSelectedFn } from "../model/selectedCells/selector";
import { getMappingNodeId } from "../model/spread/selector";
import { Spread, SpreadFinancialValue } from "../model/spread/types";

const valueClass = (
  isSelected: boolean,
  isHighlighted: boolean,
  index: number
): string =>
  classnames(
    "AccountRow__value",
    "AccountRow__value--value",
    `AccountRow__value--period-${index + 1}`,
    {
      "AccountRow__value--selected": isSelected,
      "AccountRow__value--highlighted": isHighlighted
    },
    "AccountRow__value--with-icon"
  );

interface ValueCellBaseProps {
  account: AccountPresenter;
  periodValue: number | undefined;
  period: number;
}

interface ValueCellRawProps extends ValueCellBaseProps {
  lens: CorrectLens<Spread, SpreadFinancialValue>;
  period: number;
}

interface ValueCellProps extends ValueCellRawProps {
  selectCell: typeof selectCell;
  isSelected: boolean;
  isHighlighted: boolean;
  mappingNodeId: string | null;
}

export class ValueCell extends React.Component<ValueCellProps> {
  public handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();

    const { account, period, mappingNodeId } = this.props;

    if (!isRequesting(actions.updateAccount) && mappingNodeId === null) {
      this.props.selectCell({
        period,
        account
      });
    }
  };

  public render() {
    const { periodValue, isSelected, isHighlighted, period } = this.props;
    return (
      <div className={valueClass(isSelected, isHighlighted, period)}>
        {this.props.children}
        <div onClick={this.handleClick}>
          {(periodValue || periodValue === 0) && formatMoneyValue(periodValue)}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: State, ownProps: ValueCellRawProps) => ({
  isSelected: getCellSelectedFn(state)(
    ownProps.account.spreadSheetType,
    ownProps.account.id,
    ownProps.period
  ),
  isHighlighted: getHighlightedCellFn(state)(
    ownProps.account.spreadSheetType,
    ownProps.account.id,
    ownProps.period
  ),
  mappingNodeId: getMappingNodeId(state)
});

export default connect(
  mapStateToProps,
  { selectCell }
)(ValueCell);



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/ValueCell.tsx